import { compose } from 'redux';
import withTranslation from '../../components/_hoc/withTranslation';
import { connect, useDispatch } from 'react-redux';
import withModal from '../../components/_hoc/withModal';
import {
  comparePhotoModule,
  loadTableData,
  clearState,
  orderUp,
  orderDown,
  deleteOrder
} from './ComparePhotoDucks';
import useTableFilter from '../../components/TableFilter/useTableFilter';
import i18next from 'i18next';
import React, { useEffect } from 'react';
import BreadCrumbs from '../../components/BreadCrumbs/BreadCrumbs';
import Paper from '@material-ui/core/Paper';
import './ComparePhotoTranslate';

import { comparePhotoColumns } from './ComparePhotoColumns';
import StaticTablePagination from '../../_ui/Table/StaticTablePaginated';
import CreateOrderModal from './modal/CreateOrderModal';
import Button from '../../_ui/Button/Button';
import AddIcon from '@material-ui/icons/Add';
import { useHistory } from 'react-router-dom';
import useSimpleModal from '../../components/_hooks/useSimpleModal';

function ComparePhotoPage({
  t,
  lang,
  loadingTable,
  tableData,
  loadTableData,
  clearState
}) {
  const { filter, nextPage } = useTableFilter(loadTableData, undefined, '1');
  const breadCrumbItems = [
    { name: i18next.t('breadcrumbs_home'), href: '/' },
    { name: i18next.t('breadcrumbs_comparePhoto') }
  ];
  const dispatch = useDispatch();

  const addOrderModal = useSimpleModal();
  const history = useHistory();

  useEffect(() => {
    return () => clearState();
  }, [clearState]);

  const taskOrderUp = taskId => {
    dispatch(orderUp(taskId, filter));
  };
  const taskOrderDown = taskId => {
    dispatch(orderDown(taskId, filter));
  };
  const taskDelete = taskId => {
    dispatch(deleteOrder(taskId, filter));
  };

  return (
    <>
      <BreadCrumbs items={breadCrumbItems} />
      <Paper className="pb3 pt1 px3" style={{ minWidth: 1800 }}>
        <h3>{t('comparePhotoPage_title')}</h3>
        <div className="mb2 ">
          <Button
            icon={<AddIcon fontSize="small" className="mr1" />}
            size="small"
            text={t('comparePhotoPage_add')}
            onClick={() => addOrderModal.open({})}
          />
        </div>
        <StaticTablePagination
          columns={comparePhotoColumns({
            t,
            lang,
            taskOrderUp,
            taskOrderDown,
            taskDelete,
            history
          })}
          data={tableData.content}
          sortable={false}
          totalElements={tableData.totalElements}
          onClickLoadMore={() => nextPage()}
          loading={loadingTable}
        />
        {addOrderModal.isOpen && <CreateOrderModal close={addOrderModal.close} />}
      </Paper>
    </>
  );
}

export default compose(
  withTranslation,
  connect(
    state => ({
      loadingTable: state[comparePhotoModule].loadingTable,
      tableData: state[comparePhotoModule].tableData
    }),
    { loadTableData, clearState }
  )
)(withModal(ComparePhotoPage));
